import { useEffect, useState } from "react";
import { getEventTimingStatus } from "../utils/eventTiming";

export const useEventTiming = (eventData, countdown = true) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    setNow(Date.now());
    const interval = setInterval(() => {
      const current = Date.now();
      const timing = getEventTimingStatus(eventData, new Date(current));
      setNow((previous) => {
        if (countdown && timing.isUpcoming) return current;
        const previousTiming = getEventTimingStatus(eventData, new Date(previous));
        return previousTiming.status === timing.status ? previous : current;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [eventData, countdown]);

  const timing = getEventTimingStatus(eventData, new Date(now));
  const remaining = timing.isUpcoming && timing.start
    ? Math.max(0, timing.start.getTime() - now)
    : 0;

  return {
    ...timing,
    timeLeft: {
      days: Math.floor(remaining / 86400000),
      hours: Math.floor((remaining % 86400000) / 3600000),
      minutes: Math.floor((remaining % 3600000) / 60000),
      seconds: Math.floor((remaining % 60000) / 1000),
    },
  };
};
